import HelperService from "../services/helper-service";
import React from "react";

export default function StarRating({rating, count, starClass="text-warning", showCount=false, ...props}) {
    const stars = HelperService.round(rating, 0.5);
    const halfStar = parseInt(stars)===stars ? 0 : 1;
    return (<div title={`FitPro rating is ${rating}` + (count ? ` based on ${count} reviews` : '')} className={showCount ? 'd-flex gap-2 flex-wrap' : ''}>
        <div>
            {[...Array(parseInt(stars))]
                .map((item, i) => <span key={'full-' + i} className={`mdi mdi-star ${starClass}`}></span>)}
            {[...Array(halfStar)]
                .map((item, i) => <span key={'half-' + i}
                                        className={`mdi mdi-star-half-full ${starClass}`}></span>)}
            {[...Array(5 - parseInt(stars + halfStar))]
                .map((item, i) => <span key={'empty-' + i} className="mdi mdi-star text-secondary"></span>)}
        </div>
        {showCount && <span className="text-secondary fs-7">({count})</span>}
    </div>);
}
